import { render, staticRenderFns } from "./LeadsStorage.vue?vue&type=template&id=03c3e130&scoped=true"
import script from "./LeadsStorage.vue?vue&type=script&lang=js"
export * from "./LeadsStorage.vue?vue&type=script&lang=js"
import style0 from "./LeadsStorage.vue?vue&type=style&index=0&id=03c3e130&prod&lang=css"
import style1 from "./LeadsStorage.vue?vue&type=style&index=1&id=03c3e130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c3e130",
  null
  
)

export default component.exports